export default {
  loginMessage: { method: 'get', url: '/api/v1/auth/loginMessage' }, //获取签名字符串
  isRegister: { method: 'post', url: '/api/v1/auth/isRegister' }, //是否注册
  login: { method: 'post', url: '/api/v1/auth/login' }, //登录
  index: { method: 'get', url: '/api/v1/index/index' }, //首页
  userInfo: { method: 'get', url: '/api/v1/user/info' }, //用户信息
  config: { method: 'get', url: '/api/v1/node/config' }, //节点配置
  nodeBuy: { method: 'get', url: '/api/v1/node/buy' }, //节点购买
  nodeBuyList: { method: 'get', url: '/api/v1/node/buyList' }, //节点购买记录
  productList: { method: 'get', url: '/api/v1/product/list' }, //商品列表
  productDetail: { method: 'get', url: '/api/v1/product/detail' }, //商品详情
  teamList: { method: 'get', url: '/api/v1/user/zhiList' }, //团队列表
  liberateLog: { method: 'get', url: '/api/v1/liberate/log' }, //释放记录
  lonReleaseInfo: { method: 'get', url: '/api/v1/lonRelease/info' }, //获取充值释放统计数据
  lonReleaseGetOrder: { method: 'post', url: '/api/v1/lonRelease/getOrder' }, //获取充值订单信息
  lonReleaseLog: { method: 'get', url: '/api/v1/lonRelease/log' } //获取充值记录列表
}
